import styles from './error.css';
import React, { useEffect } from 'react';
import { useTranslation } from '../hooks/translate';
import warningImage from '../images/warning.svg';
import { ROUTES } from '../constants/routes';

/**
 * Error view.
 */
export function Error({ error, setRoute }) {
  const [translate] = useTranslation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setRoute(ROUTES.readyToCast);
    }, 5000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={styles.main}>
      <img src={warningImage}></img>
      <p className={styles.text}>{translate(error.text)}</p>
      <p className={styles.subtext}>{translate(error.subtext)}</p>
    </div>
  );
}
